<ion-header class="ion-no-border">
  <ion-toolbar class="no-safe-area-top">
    <ion-title class="fs-5 font600 ion-no-padding marl20 header-title">{{
      "flight.passenger_count_modal.header" | translate
    }}</ion-title>
    <ion-icon
      class="primary-icon-color"
      name="close-outline"
      size="large"
      slot="end"
      (click)="closeModal()"
      class="marr10"
    ></ion-icon>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="d-flex ion-justify-content-between ion-align-items-center">
    <p class="fs-3 font600">
      {{ "flight.passenger_count_modal.adult" | translate }} (13+
      {{ "flight.passenger_count_modal.years" | translate }})
    </p>
    <counter-buttons
      (addFunction)="add('adult')"
      (removeFunction)="subtract('adult')"
      [item]="'adult'"
      [quantity]="travellerCount?.adult"
      [containerStyle]="{
        'min-width': '131px',
        height: '40px',
        'border-radius': '5px'
      }"
    ></counter-buttons>
  </div>
  <div class="d-flex ion-justify-content-between ion-align-items-center">
    <p class="fs-3 font600">
      {{ "flight.passenger_count_modal.children" | translate }} (2-13
      {{ "flight.passenger_count_modal.years" | translate }})
    </p>
    <counter-buttons
      (addFunction)="add('children')"
      (removeFunction)="subtract('children')"
      [item]="'children'"
      [quantity]="travellerCount?.children"
      [containerStyle]="{
        'min-width': '131px',
        height: '40px',
        'border-radius': '5px'
      }"
    ></counter-buttons>
  </div>
  <div class="d-flex ion-justify-content-between ion-align-items-center">
    <p class="fs-3 font600">
      {{ "flight.passenger_count_modal.infants" | translate }} ({{
        "flight.passenger_count_modal.below" | translate
      }}
      2 {{ "flight.passenger_count_modal.years" | translate }})
    </p>
    <counter-buttons
      (addFunction)="add('infant')"
      (removeFunction)="subtract('infant')"
      [item]="'infant'"
      [quantity]="travellerCount?.infant"
      [containerStyle]="{
        'min-width': '131px',
        height: '40px',
        'border-radius': '5px'
      }"
    ></counter-buttons>
  </div>

  <ion-button
    class="ion-no-margin ion-margin-vertical primary-btn"
    expand="block"
    (click)="closeModal()"
  >
    {{ "flight.passenger_count_modal.done" | translate }}
  </ion-button>
</ion-content>